import toast from "react-hot-toast";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";
import { TOAST_MESSAGES } from "../constants";
import { useState } from "react";
import { deleteReturnNote, getReturnNotes, getReturnNotesById, patchReturnNote, postReturnNote } from "../../../Services/returnNoteServices";

export const useReturnNote = () => {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    search: null,
    product: null,
    warehouse: null,
  });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const onPageChange = (newPage) => setPage(newPage);

  const onPageSizeChange = (newSize) => {
    setRowsPerPage(newSize);
    setPage(1);
  };

  
  const fetchReturnNotes = async (params) => {
    setLoading(true);
    var data = null;
    try {
      const response = await getReturnNotes({
        ...params,
        ...filters,
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
      });
      if (response.status === 200) {
        setTotalPages(Math.max(1, Math.ceil((response.data?.count || 0) / rowsPerPage)));
        data = response.data?.results;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.FETCH_RETURNNOTE_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.FETCH_RETURNNOTE_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const fetchReturnNotesById = async (id) => {
    setLoading(true);
    var data = null;
    try {
      const response = await getReturnNotesById(id);
      if (response.status === 200) {
        data = response.data;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.FETCH_RETURNNOTE_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.FETCH_RETURNNOTE_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const createReturnNote = async (payload) => {
    setLoading(true);
    var data = null;
    try {
      const response = await postReturnNote(payload);
      if (response.status === 201) {
        data = response.data;
        const msg = TOAST_MESSAGES.CREATE_RETURNNOTE_SUCCESS;
        toast.success(msg);
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.CREATE_RETURNNOTE_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.CREATE_RETURNNOTE_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const updateReturnNote = async (rn_id, payload) => {
    setLoading(true);
    var data = null;
    try {
      const response = await patchReturnNote(rn_id, payload);
      if (response.status === 200) {
        data = response.data;
        const msg = TOAST_MESSAGES.UPDATE_RETURNNOTE_SUCCESS;
        toast.success(msg);
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.UPDATE_RETURNNOTE_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.UPDATE_RETURNNOTE_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };
  
  const deleteReturnNoteById = async (id) => {
    setLoading(true);
    var data = null;
    try {
      const response = await deleteReturnNote(id);
      if (response.status === 204) {
        toast.success(TOAST_MESSAGES.DELETE_RETURNNOTE_SUCCESS);
        data = true;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.DELETE_RETURNNOTE_FAILED;
        toast.error(msg);
        data = false;
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.DELETE_RETURNNOTE_FAILED
      );
      data = false;
    } finally {
      setLoading(false);
      return data;
    }
  };

  return {
    loading,
    filters,
    setFilters,
    page,
    totalPages,
    rowsPerPage,
    onPageChange,
    onPageSizeChange,
    fetchReturnNotes,
    fetchReturnNotesById,
    createReturnNote,
    updateReturnNote,
    deleteReturnNoteById
  }
}